import React from 'react';
import { CancelUncancelResultTemplate } from 'themes/modules/order/pages';
import { CancelUncancelResultViewStore } from '../stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new CancelUncancelResultViewStore(rootStore, componentProps), 'cancelUncancelResultViewStore')
class CancelUncancelResult extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <CancelUncancelResultTemplate {...this.props} />;
    }
}

export default CancelUncancelResult;
